import { render, staticRenderFns } from "./hostdetail.vue?vue&type=template&id=2c5630fa&"
import script from "./hostdetail.vue?vue&type=script&lang=js&"
export * from "./hostdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports